<template>
 
      <div class="outer">
          <div class=" vertFlex fullheight right10 rightline">
            <label for="grouplist" class="titlelabel">Groups</label>
            <label class="checkboxLabel" style="font-size:small;" title="Attribute categories are the size / color / grade values used to build the storefront product filters. They are hidden by default so this list stays focused on real product groups.">
                <input type="checkbox" v-model="showAttributeCategories"> Show attribute categories (sizes/colors/grades)
            </label>
            <p style="font-size:x-small; margin:0 0 6px 0; color:#666;">Size / color / grade values used for storefront filters — hidden by default.</p>
            <div class="scrolldiv" v-if="displayedGroups.length>0" tabindex="0">
                <div id="grouplist" v-for="result in displayedGroups" :key="result.id" :value="result.id" >
                    <list-item :topLeft="displayName(result)"  bottomLeft=""    @click="selectGroup(result)"
                        :selected="result.id==selectedGroupID" :inactive="!result.isActive">
                    </list-item>
                </div>
            </div>
            <p v-else class="messagetext">No product groups yet. Use "Add" below to create one.</p>
            <div class="horizFlex" v-if="selectedGroupID>0">
                <smallbutton toplabel="Up" @click="moveGroupUp()" class="button primarybutton narrowButton"></smallbutton>
                <smallbutton toplabel="Down" @click="moveGroupDown()" class="button primarybutton narrowButton"></smallbutton>
            </div>
            <div class="horizFlex">
                <addgroup :showButton="isTrue" @saved="getGroups" buttonclass="button buttonprimary narrowButton"/>
                <renamegroup :showButton="isTrue" @saved="getGroups" :productGroup="selectedGroup" buttonclass="button buttonprimary narrowButton" v-if="selectedGroupID>0"/>
                <confirm :showButton="isTrue" body="Do you want to remove the selected group?" title="Remove" @yes="removeGroup()" v-if="selectedGroupID>0" buttonclass="button buttonprimary narrowButton"/>
            </div>
          </div>
          <div class=" vertFlex " >
            <label  class="titlelabel">Available Products at {{selectedGroupLocationName}}</label>
            <formentry inputid="productfilter" label="Filter By" placeholder="filter products"  v-model="filterby"/>
            <label  class="pleasewait" v-if="pleaseWait">Please wait...</label>
            <label  class="responsemessage" v-if="responseMessage!=''">{{responseMessage}}</label>
            <div class="scrolldiv" tabindex="0">
            <div v-for="result in filteredproductList" :key="result.id" :value="result.id" >
                <list-item :topLeft="getProductDisplayName(result)"  bottomLeft=""    @click="selectProduct(result)" @dblclick="addProduct()"
                    :selected="result.id==selectedProductID" :inactive="!result.isActive">
                </list-item>  
            </div>
            </div>
          </div>
          <smallbutton toplabel="Add to Group >" @click="addProduct()"  :disabled="productList.length==0" buttonclass="button buttonprimary addbutton"/>
          <div class=" vertFlex  "  v-if="groupProductList.length>0">
            <label for="grouplist" class="titlelabel">{{selectedGroupName}} Products</label>
            <div class="scrolldiv">
            <div class="horizFlexWrap ">
                <div id="grouplist" v-for="result in groupProductList" :key="result.id" :value="result.id" >
                    <list-item :topLeft="getProductDisplayName(result)"  bottomLeft=""    @click="selectGroupProduct(result)" @dblclick="removeProduct()"
                        :selected="result.id==selectedGroupProductID" :inactive="!result.isActive">
                    </list-item>  
                </div>
            </div>
            </div>
            <div>
                <div class="horizFlex">
                    <smallbutton toplabel="Up" @click="moveUp()" class="button primarybutton narrowButton"></smallbutton>
                    <smallbutton toplabel="Down" @click="moveDown()" class="button primarybutton narrowButton"></smallbutton>
                    <smallbutton toplabel="Remove" @click="removeProduct()" ></smallbutton>
                    
                </div>
            </div>
            
            
          </div>
      </div>
    
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import listItem from './group.vue'
import smallbutton from '../controls/button.vue'
import addgroup from '../actions/addgroup.vue'
import renamegroup from '../actions/renamegroup.vue'
import confirm from '../actions/confirm.vue'
import datamethods from '../../services/datamethods.js'
import formentry from '../controls/entry.vue'
export default {
    name:'productgroup',
    components:{
        listItem,
        smallbutton,
        addgroup,
        confirm,
        renamegroup,
        formentry
      
 
    },
    mixins:[datamethods],
    computed:{
         ...mapFields([
            'pleaseWait',
            'responseMessage',
            'selectedGroupID',
           'selectedGroupName',
           'selectedGroup',

           'selectedGroupLocationId',
           'selectedGroupLocationName',
           'selectedProductID',
           'selectedProductName',
           'selectedProductPrice',
           'selectedGroupProductID',
           'selectedGroupProductName',
           'groupList',
           'productList',
           'groupProductList',
           'securityAppName'
         ]),
         filteredproductList(){
            if(this.filterby==null){
                return this.productList
            }else{
                var filtered =[]
                let filterbystring = this.filterby.toLowerCase()
                this.productList.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let p=arr[index]
                    if(p.name.toLowerCase().includes(filterbystring) ){
                        filtered.push(p)
                    }
                } 
                return filtered
            }
         },
         showLibrary(){

            if(window.SHOW_LIBRARY==undefined){return false}
            else{return window.SHOW_LIBRARY}
        },
        // Product groups minus the attribute-facet categories (Size=2/Gender=3/Color=4/Grade=5),
        // which are hidden by default. Real groups = Department(1)/Featured(6)/NULL type.
        displayedGroups(){
            if(this.showAttributeCategories){ return this.groupList }
            var attrTypes = this.ATTRIBUTE_CATEGORY_TYPE_IDS
            return this.groupList.filter(function(g){
                return attrTypes.indexOf(g.productCategoryTypeId) === -1
            })
        }

    },
    mounted(){
        this.getGroups();
        //this.getProducts();
    },
    data(){
        return{
           filterby:null,
           isTrue:true,
           showAttributeCategories:false,
           // ProductCategoryType IDs treated as attribute facets (Size/Gender/Color/Grade),
           // hidden from the Groups list by default. Mirrors dbo.ProductCategoryType.
           ATTRIBUTE_CATEGORY_TYPE_IDS:[2,3,4,5]
        }
    },
    methods:{
        filterproducts(){
        },
        getProductDisplayName(result){
            var price =''
            if (result.price) {
                price= "$" + Number(result.price).toFixed(2);
            }
      
            return result.name + ' ' + price
        },
        displayName(result){
            return result.name + " - " + result.locationName 
        },
        async addProduct(){
            if(this.selectedGroupID<=0 || this.selectedProductID<=0){
                this.responseMessage = "Select a group and a product first"
                return
            }
            //if already in group... msg
            if(this.isInGroup(this.selectedProductID)){
                this.responseMessage = this.selectedProductName + " is already in the group"
                return
            }
            //determine highest ordinal
            var ord = 0
            if(this.groupProductList.length>0){
                ord=this.groupProductList[this.groupProductList.length-1].ordinal + 1
            }
            let req = {
                productId:this.selectedProductID,
                productGroupId:this.selectedGroupID,
                isActive:true,
                ordinal:ord
            }
             this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'ecommerce/admin/producttogroup')
            //handle response
            if(response.Successful){
                 var p={
                    id:this.selectedProductID,
                    name:this.selectedProductName,
                    isActive:true,
                    ordinal:ord,
                    price:this.selectedProductPrice
                }
                this.groupProductList.push(p)

                //var index = this.productList.findIndex(x=>x.id===this.selectedProductID)
                //this.productList.splice(index,1)
                
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
            

        },
        isInGroup(id){
            var inGrp = false
            this.groupProductList.forEach(myFunction2)
            
            function myFunction2(item, index, arr) {
                let p=arr[index]
                if(p.id==id){
                    inGrp= true
                }
            } 
            return inGrp //didn't find it
        },
        async removeProduct(){
            if(this.selectedGroupProductID<=0){
                this.responseMessage = "Select a product in the group to remove"
                return
            }
            let req = {
                productId:this.selectedGroupProductID,
                productGroupId:this.selectedGroupID,
                isActive:false,
                ordinal:this.groupProductList.length
            }
             this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'ecommerce/admin/producttogroup')
            //handle response
            if(response.Successful){
                 var p={
                    id:this.selectedGroupProductID,
                    name:this.selectedGroupProductName,
                    isActive:true
                }
                //this.productList.push(p)

                var index = this.groupProductList.findIndex(x=>x.id===this.selectedGroupProductID)
                this.groupProductList.splice(index,1)
                    
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
            
        },
        async removeGroup(){
            let req = {
                productGroup:{
                    id:this.selectedGroupID
                }
            }
             this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'ecommerce/admin/removeproductgroup')
            //handle response
            if(response.Successful){
                this.getGroups();
               
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
        moveUp(){
            
            var index = this.groupProductList.findIndex(x=>x.id===this.selectedGroupProductID)
            if(index<=0){return}
            this.swap(this.groupProductList,index-1,index)
            
        },
        async swap(array,index1, index2){
            //p1 update ordinal
            let req = {
                productId:array[index1].id,
                productGroupId:this.selectedGroupID,
                isActive:true,
                ordinal:array[index2].ordinal
            }
             this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'ecommerce/admin/producttogroup')
            //handle response
            if(response.Successful){
                //update the second ordinal
                 let req2 = {
                    productId:array[index2].id,
                    productGroupId:this.selectedGroupID,
                    isActive:true,
                    ordinal:array[index1].ordinal
                }
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req2,'ecommerce/admin/producttogroup')  
                if(response.Successful){
                    //swap local 
                    //first the ordinals
                   var tmpord = array[index1].ordinal
                   array[index1].ordinal = array[index2].ordinal
                   array[index2].ordinal = tmpord

                   //then the actual array items
                   var tmp = array[index1]
                    array[index1]=array[index2]
                    array[index2]=tmp

                }else{
                    // first ordinal changed but second failed — surface it (order may be off; refresh the group)
                    this.responseMessage = (response.Message || 'Reorder partially failed — refresh the group')
                }
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;



            
        },
        moveDown(){
            
            var index = this.groupProductList.findIndex(x=>x.id===this.selectedGroupProductID)
            if(index<0 || index==this.groupProductList.length-1){return}
            this.swap(this.groupProductList,index+1,index)
        },
        async selectGroup(result){
            this.selectedGroupID=result.id
            this.selectedGroup=result
            this.selectedGroupName=result.name
            this.selectedGroupLocationId=result.locationId
            this.selectedGroupLocationName  = result.locationName
            //get group data
            let req = {
                locationId:this.selectedGroupLocationId,
                productGroupId:result.id,
                applicationName:this.securityAppName
            }
             this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'ecommerce/admin/products_bygroup')
            //handle response
            if(response.Successful){
                 this.groupProductList=response.productList
                this.getProducts(); //get products related to this location
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false; 
          
        },
        selectGroupProduct(result){
            this.selectedGroupProductID=result.id
            this.selectedGroupProductName=result.name
        },
        selectProduct(result){
            this.selectedProductID=result.id
            this.selectedProductName=result.name
            this.selectedProductPrice=result.price
        },
        async getGroups(){
            let req = {
                locationId:-1
            }
             this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'ecommerce/admin/productgroup_all')
            //handle response
            if(response.Successful){
                 this.groupList=response.ProductGroupList
                 await this.sortGroupsByStoreOrder()
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
        // Order the Groups list to match the storefront (Ecommerce_ProductCategory.DisplayOrder),
        // so the Up/Down movers reflect and control the on-store sequence.
        async sortGroupsByStoreOrder(){
            try{
                var resp = await this.callAPI_Get('ecommerce/categories/db?visibleOnly=false')
                if(resp && resp.Successful && resp.categories){
                    var orderByPcid = {}
                    resp.categories.forEach(function(c){ orderByPcid[c.categoryId] = c.displayOrder })
                    this.groupList = this.groupList.slice().sort(function(a,b){
                        var ao = orderByPcid[a.id], bo = orderByPcid[b.id]
                        if(ao==null && bo==null) return 0
                        if(ao==null) return 1   // groups not published online sort last
                        if(bo==null) return -1
                        return ao - bo
                    })
                }
            }catch(e){ /* non-fatal: leave server order if the category-order lookup fails */ }
        },
        moveGroupUp(){
            var i = this.groupList.findIndex(g => g.id === this.selectedGroupID)
            if(i<=0) return
            this.swapGroups(i-1, i)
        },
        moveGroupDown(){
            var i = this.groupList.findIndex(g => g.id === this.selectedGroupID)
            if(i<0 || i===this.groupList.length-1) return
            this.swapGroups(i, i+1)
        },
        async swapGroups(i1, i2){
            var arr = this.groupList.slice()
            var tmp = arr[i1]; arr[i1] = arr[i2]; arr[i2] = tmp
            this.groupList = arr
            await this.saveGroupOrder()
        },
        // Persist the current Groups order to Ecommerce_ProductCategory.DisplayOrder (10,20,30...).
        async saveGroupOrder(){
            var orders = this.groupList.map(function(g, idx){ return { pcid: g.id, order: (idx+1)*10 } })
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI({ productCategoryOrders: orders }, 'ecommerce/admin/reorderproductgroups')
            if(!response.Successful){ this.responseMessage = response.Message || 'Failed to save group order' }
            this.pleaseWait=false;
        },
        async getProducts(){
            let req = {
                locationId:this.selectedGroupLocationId
            }
             this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'ecommerce/admin/productbylocation')
            //handle response
            if(response.Successful){
                 this.productList=response.productList
                this.productList.sort(compare)

                function compare(a,b){
                    if(a.name< b.name){
                        return -1;
                    }
                    if(a.name > b.name){
                        return 1;
                    }
                    return 0;
                }

            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false; 
        },
        
    }
}
</script>

<style>
.outer{
  height:70vh;
     margin:0px;
    display:grid;
    grid-template-columns:2fr 2fr 1fr 4fr;
    grid-template-rows:auto;

}
.narrowButton{
    width:40px;
}
.addbutton{
    width:150px;
    margin-top:33px;
}
.scrolldiv{
    overflow-x:hidden;
    overflow-y:auto;
    height:60vh;
}
</style>


/* this.groupList=[
                {
                    id:1,
                    name:'Group 1',
                    locationName:'loc1',
                    isActive:true,
   
                },
                {
                    id:2,
                    name:'Group 2',
                    locationName:'loc1',
                    isActive:true,
                    
                },
                {
                    id:3,
                    name:'Group 3',
                    locationName:'loc2',
                    isActive:true,
                  
                },
            ] */

            this.groupProductList=[
                {
                    id:1,
                    name:'Product Nice 1',
                    isActive:true
                },
                {
                    id:2,
                    name:'Product Long Name 2',
                    isActive:true
                },
                {
                    id:3,
                    name:'Product 3',
                    isActive:true
                }
            ]